(function() {
  document.addEventListener("DOMContentLoaded", () => {
    const searchInput = document.querySelector(".filters input");
    const priceSelect = document.querySelector("#price");
    const tagSelect = document.querySelector("#tags")
    const productCards = document.querySelectorAll(".bhc-product");
    const toggle = document.getElementById("stockToggle");

    
    let stockValue = 'in-stock'
    function filterProducts() {
      const searchValue = searchInput.value.toLowerCase();
      const priceValue = priceSelect.value;
      const tagValue = tagSelect.value;
      let isProductFound = false
      productCards.forEach(card => {
        const title = card.dataset.title.toLowerCase();
        const price = parseFloat(card.dataset.price);
        const inStock = card.dataset.stock === "true";
        const tags = card.dataset.tags?.split(',');
        
        // Search
        const matchesSearch = title.includes(searchValue);

        // Price
        let matchesPrice = true;
        switch (priceValue) {
          case "25":
            matchesPrice = price < 25;
            break;
          case "25-50":
            matchesPrice = price >= 25 && price <= 50;
            break;
          case "50-100":
            matchesPrice = price >= 50 && price <= 100;
            break;
          case "100":
            matchesPrice = price > 100;
            break;
          default:
            matchesPrice = true;
        }

        // Stock
        let matchesStock = true;
        if (stockValue === "in-stock") {
          matchesStock = inStock;
        }
        if (stockValue === "out-of-stock"){
           matchesStock = !inStock;
        }

        //Tags
        console.log('tags-length', tags.length)
        console.log('tag-value', tagValue)

        let matchTags = true
        if(tagValue != '-1') {
          if(tags.length) {
            if(!tags.includes(tagValue)){
              matchTags = false
            }
        }
        } 

        if (matchesSearch && matchesPrice && matchesStock && matchTags) {
          card.style.display = "block";
          isProductFound = true;
        } else {
          card.style.display = "none";
        }
      }); 

      const noItemsEl = document.getElementById('no-items')
      if(isProductFound) {
        noItemsEl.style.display = 'none';
      }else {
        noItemsEl.style.display = 'block';
      }

    } 

   
    searchInput.addEventListener("input", filterProducts);
    priceSelect.addEventListener("change", filterProducts);
    tagSelect.addEventListener("change", filterProducts);
    toggle.addEventListener("click", (e) => {
    
      toggle.classList.toggle("in-stock");
      toggle.classList.toggle("out-of-stock");
      stockValue = e.target.dataset.value
      filterProducts()
      
    });

  }); 
})(); 
